; (function () {
    document.addEventListener("DOMContentLoaded", function (event) {
        const animatedEls = document.querySelectorAll('.scroll-fade-in-effect');
        const reduceMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        //disable animation if user prefers reduced motion!
        //ReduceMotionMediaQuery to be supported by Chrome from v74+ April 23 2019
        //once widely supported, outsource all css animations to separate stylesheet loaded conditionally via *media* attribute on link element
        // eg. <link rel="stylesheet" href="animations.css" media="(prefers-reduced-motion: no-preference)">
        if (animatedEls && !reduceMotionPreference.matches) {
            //normal forEach not supported by IE
            //alternative use const someArray = [].slice.call(document.querySelectorAll("some-mass-selector")); with normal forEach
            //Array.prototype.forEach.call(animatedEls, (animatedEl) => {
            //    animatedEl.classList.add("is-hidden");
            //});

            const observerConfig = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5
            };

            const intersectionObserver = new IntersectionObserver(function (entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        ////entry.target.classList.remove("is-hidden");
                        entry.target.classList.add("is-animated");
                        intersectionObserver.unobserve(entry.target);
                    }
                });
            }, observerConfig);

            Array.prototype.forEach.call(animatedEls, (animatedEl) => {
                intersectionObserver.observe(animatedEl);
            });
        } else {
            //console.log('user prefers reduced motion: animations disabled');
        }
    });
})();